import Vue from 'vue';
import Noty from 'noty';
import Spinner from '@jgile/laravel-vue/resources/js/components/Spinner';
import { resolveElement } from '@jgile/laravel-vue/resources/js/util';

const VueInstance = new Vue();

export default {
    toast(type, message) {
        new Noty({
            text: message,
            type: type,
            timeout: 3000,
            theme: 'bootstrap-v4',
            visibilityControl: false,
        }).show();
    },
    modal(id, modal) {
        Bus.$emit('newMessengerModal', { id: id, modal: modal });
    },
    info(msg) {
        this.toast('info', msg);
    },
    error(msg) {
        this.toast('error', msg);
    },
    success(msg) {
        this.toast('success', msg);
    },
    warning(msg) {
        this.toast('warning', msg);
    },
    alert(msg) {
        this.toast('alert', msg);
    },
    loading(el = 'body', options = {}, content = null) {
        let resolvedEl = resolveElement(el)[0];

        if (!$.data(resolvedEl, 'loader')) {
            $.data(
                resolvedEl,
                'loader',
                Vue.$loading.show(
                    _.merge(
                        {
                            isFullPage: el === 'body',
                            container: el === 'body' ? null : resolvedEl,
                            backgroundColor: '#ffffff',
                            color: '#000000',
                            opacity: 0.5,
                        },
                        options,
                    ),
                    {
                        default:
                            content !== null
                                ? content
                                : VueInstance.$createElement(Spinner, {
                                    attrs: {},
                                }),
                    },
                ),
            );
        }
    },
    loaded(el = 'body') {
        el = resolveElement(el)[0];

        if ($.data(el, 'loader')) {
            $.data(el, 'loader').hide();
            $.removeData(el, 'loader');
        }
    },
};
